import { DocumentTypeEnum } from 'api-hooks/order/travel-document';
import { capitalize } from 'common/utils/string';
import HOCInput from 'components/common/hoc-input';
import Separator from 'components/common/separator';
import { Input } from 'components/elements';
import Text from 'components/elements/text';
import { DocumentPurchaseItemGuestFormType } from 'legacy-modules/order/travel-document/components/form-type';
import {
  CardSection,
  FullContainer,
  HalfContainer,
  SectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import AddOnsTable from './tables/add-ons-table';
import InsuranceTable from './tables/insurance-table';
import PassportTable from './tables/passport-table';
import VisaDetailTable from './tables/visa-detail-table';
import VisaTable from './tables/visa-table';

export default function DocumentPurchaseItems() {
  const { t } = useTranslation();
  const name: any = 'approvalable.documentPurchases';
  const { control } = useFormContext();
  const documentPurchases = useWatch({ control, name });

  return (
    <>
      {documentPurchases.map((documentPurchase, idx) => {
        return (
          <React.Fragment key={documentPurchase.id}>
            <CardSection>
              <FullContainer>
                <Text variant="HeadingXSmall">
                  {t('document:document_details')} {idx + 1}
                </Text>
                <Separator gap={16} />
                <SectionContainer>
                  <HalfContainer>
                    <Input
                      type="text"
                      name={`${name}.${idx}.documentType`}
                      label={t('document:document_type')}
                    />
                  </HalfContainer>
                </SectionContainer>
                <Separator gap={16} />
                <HOCInput keys={[`${name}.${idx}.documentType`]}>
                  {(values) => {
                    const documentType = values[`${name}.${idx}.documentType`];

                    switch (documentType) {
                      case capitalize(DocumentTypeEnum.visa):
                        return (
                          <HOCInput
                            keys={[
                              `${name}.${idx}.documentPurchaseGuests`,
                              name[idx],
                            ]}
                          >
                            {(values) => {
                              const guests = (values[
                                `${name}.${idx}.documentPurchaseGuests`
                              ] || []) as DocumentPurchaseItemGuestFormType[];

                              return (
                                <>
                                  <VisaTable parentIndex={idx} />
                                  <Separator gap={24} />
                                  {guests.map((guest, guestIndex) => {
                                    return guest.details?.map(
                                      (detail, detailIndex) => (
                                        <>
                                          {detailIndex === 0 && (
                                            <>
                                              <Text variant="LabelMedium">
                                                {guest.guestName}
                                              </Text>
                                              <Separator gap={24} />
                                            </>
                                          )}

                                          <VisaDetailTable detail={detail} />
                                          <Separator gap={24} />
                                        </>
                                      ),
                                    );
                                  })}
                                  <Separator gap={24} />
                                  <AddOnsTable parentIndex={idx} />
                                </>
                              );
                            }}
                          </HOCInput>
                        );
                      case capitalize(DocumentTypeEnum.insurance):
                        return (
                          <>
                            <InsuranceTable parentIndex={idx} />
                            <Separator gap={24} />
                            <AddOnsTable parentIndex={idx} />
                          </>
                        );
                      case capitalize(DocumentTypeEnum.passport):
                        return (
                          <>
                            <PassportTable parentIndex={idx} />
                            <Separator gap={24} />
                            <AddOnsTable parentIndex={idx} />
                          </>
                        );
                      default:
                        return <></>;
                    }
                  }}
                </HOCInput>
              </FullContainer>
            </CardSection>
            <Separator gap={24} />
          </React.Fragment>
        );
      })}
    </>
  );
}
